/**
 * Created by dv on 7/10/2017.
 */
import { DeleteZmCollectionMessage, DeleteZmCollectionQuery } from "../../../autogenerated/ZoomBridge";
import HashSet from './../../../protocol/HashSet';

export default class DeleteCollections {
  /**
   *
   * @param {Array<number>} collectionIds.
   */
  constructor(collectionIds) {
    this.collectionIds = collectionIds;
  }

  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }


  run() {
    const query = new DeleteZmCollectionQuery();
    const msg = new DeleteZmCollectionMessage();
    msg.setCollectionIds(this.collectionIds);
    msg.setLogMsg(this._logMsg);
    query.message = msg;
    return query.run();

  }
}
